export const provisionTypes = {
  SET_PROVISION_ITEMS: 'SET_PROVISION_ITEMS',
  SET_UNRESOLVED_ITEMS: 'SET_UNRESOLVED_ITEMS',
  SET_PROGRESS: 'SET_PROGRESS',
  SET_RAW_ITEMS: 'SET_RAW_ITEMS',
};
